import Modal from 'components/Modal/Modal'
import React from 'react'
import '../index.scss'

interface ProfilesQuantityModalProps {
  onClose: () => void
}

const ProfilesQuantityModal: React.FC<ProfilesQuantityModalProps> = ({ onClose }) => {
  return (
    <Modal
      onClose={onClose}
      icon='tabliczka'
      title='Dodano tabliczkę'
      primaryButton='Akceptuj'
      primaryButtonAction={() => alert('akcja')}
      secondaryButton='Zamknij'
      secondaryButtonAction={'close'}>
      <div className="modal__quantity">
        <h5>Czy chcesz dodać więcej profili do tabliczki?</h5>
        <p>Jedna tabliczka kosztuje 150.00 zł i zawiera jedną osobę, kazda kolejna osoba do tej tabliczki to koszt 120.00 zł</p>
        <div>
          <span>Liczba osób przypisanych do tabliczki</span>
          <div className="quantity">
            <div><i className="icon icon--minus"></i></div>
            <span>1</span>
            <div><i className="icon icon--add"></i></div>
          </div>
        </div>
      </div>

    </Modal>
  )
}

export default ProfilesQuantityModal